// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submit-tr:hover {\n  background-color: rgba(227, 236, 238, 0.85);\n}\n", ""]);
// Exports
module.exports = exports;
